export const initialState = {
  myLocations: [],
  error: '',
  isLoading: false
}
